var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-backdrop\"><div class=\"modal-dialog\"><header class=\"modal-header\"><a class=\"modal-close\"><i class=\"icon-close\"></i></a></header><section class=\"modal-body\"></section></div></div>");;return buf.join("");
};
module.exports = template;